import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://vgpgvldbeuutaarcofzb.supabase.co"
// const supabaseUrl = "http://localhost:54321"
export const supabase = createClient(supabaseUrl, "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZncGd2bGRiZXV1dGFhcmNvZnpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODQ1NzQ3OTksImV4cCI6MjAwMDE1MDc5OX0.SYCe9cte6mo-RIVq5FhPwViYzoaWIJs1VWBRCzHW6m8")